import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next';
import Head from 'next/head';

import Page from '@/components/page';
import getPageStaticPaths from '@/lib/get-page-static-paths';
import getPageStaticProps from '@/lib/get-page-static-props';
import contentService from '@/middleware/content-service';
import mapToPageEntry from '@/middleware/mappers/pages/playlist';

export const getStaticProps: GetStaticProps = getPageStaticProps({
  fetchPageFn: contentService.getPage(mapToPageEntry),
  getPageFullPath: ({ params }) => `/stations/${params?.slug}/playlist`,
});

export const getStaticPaths: GetStaticPaths = getPageStaticPaths;

type PlaylistPageProps = InferGetStaticPropsType<typeof getStaticProps>;

const PlaylistPage = (props: PlaylistPageProps) => {
  const title = `${props.page.title} Playlist`;

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Page
        isPreviewModeEnabled={props.isPreviewModeEnabled}
        page={props.page}
        navigation={props.navigation}
      />
    </>
  );
};

export default PlaylistPage;
